import { useState } from 'react';

import { toast } from '@anyx/shared-ui';

import { exportCsv } from '../api';

export const useExportBroadcastCsv = ({
  storeId,
  filters,
  platform = 'line',
}: {
  storeId: string;
  platform: 'line' | 'messenger' | 'whatsapp';
  filters?: {
    keyword?: string;
    tagName?: string;
    status?: string | string[];
    deliveredDateFrom?: string;
    deliveredDateTo?: string;
  };
}) => {
  const [loading, setLoading] = useState(false);

  const exportBroadcastCsv = async () => {
    setLoading(true);
    const success = await exportCsv({
      uri: `broadcasts/${platform}/csv`,
      params: {
        storeId,
        ...filters,
      },
    });
    setLoading(false);

    if (!success) toast.error();
  };

  return {
    loading,
    exportBroadcastCsv,
  };
};
